import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from '@angular/core';
import { externalAuthDataKey } from "../../../../authentication/services/auth.service"


@Component({
  selector: 'app-modalLanguage',
  templateUrl: '../templates/languageModal.component.html'
})
export class LanguageModalComponent implements OnInit {

  languages: any[] = [];
  errorMessage: string;

  constructor(private dialogRef: MatDialogRef<LanguageModalComponent>, @Inject(MAT_DIALOG_DATA) private data: { CancelResult: any, Languages: any[] }) {
    this.languages = this.data.Languages;
  }

  ngOnInit() {
    if (this.languages && this.languages.length === 0) {
      this.errorMessage = "User must be have available languages";
    }
  }

  select(language) {
    this.dialogRef.close(language);
  }

  close() {
    this.dialogRef.close(this.data.CancelResult);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/languageModal/components/scripts/languageModal.component.ts